export function getServerSideUserAgent() {
  return {
    'User-Agent': 'Storefront',
    'x-client-type': 'WEB',
  };
}
